import { MeditationsAPI } from "../infrastructure/api/Meditations.api";

/** A meditation's recording, as bytes fetched through our API. */
export async function fetchMeditationAudio(meditationId: string): Promise<Blob> {
    const { data } = await MeditationsAPI.audio(meditationId);
    return data;
}
